import { OfferCard2 } from "../components";
import { useInfiniteGetOffers } from "../../services";
import { Button, InfiniteScroll } from "../../../../../shared/infrastructure";
import React, { useState } from "react";
import { useOfferNotification, useOffers } from "../../store";

export const OffersHistory = (): React.ReactElement => {
  const { historyFilters, statusChangedOffers } = useOffers();
  const label = useOfferNotification("history");

  const [ignoreInitialFilter, setIgnoreInitialFilter] = useState(false);
  const { allPages, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteGetOffers("history", {
      ...historyFilters,
      ignore_default_time_filter: ignoreInitialFilter,
    });

  return (
    <React.Fragment>
      <section>{label}</section>
      <section className="h-[90%] max-h-[100%] overflow-y-auto">
        <section className="relative mx-auto grid gap-[12px] pb-[60px] xl:w-[1096px] 2xl:w-[1470px]">
          <InfiniteScroll
            isLoading={isLoading || isFetching}
            hasNextPage={!!hasNextPage}
            loadMore={fetchNextPage}
            renderItem={(offer) => (
              <OfferCard2
                key={offer.approval_id}
                data={offer}
                cardType="history"
                showHighlighted={
                  statusChangedOffers[offer.approval_id.toString()]
                }
              />
            )}
            data={allPages}
          />
          {isLoading && (
            <p className="mb-[50px] text-center text-[14px]">
              Loading offers...
            </p>
          )}
          {!isLoading && allPages.length === 0 && (
            <p className="mb-[50px] text-center text-[14px]">
              There are no offers to load
            </p>
          )}
          {!ignoreInitialFilter && hasNextPage === false && (
            <section className="mt-[50px] grid justify-items-center gap-[24px]">
              <p className="text-center text-[14px]">
                No more approvals found on the first 7th days
              </p>
              <Button
                onClick={() => setIgnoreInitialFilter(true)}
                className="w-[100px] bg-[#2196F3] text-[#FFFFFF]"
              >
                Load more
              </Button>
            </section>
          )}
        </section>
      </section>
    </React.Fragment>
  );
};
